import React from 'react';
import styled from 'styled-components';
import {SIZES, Image, Typography} from '@fupa/fupa-uikit';
import {CardSubheading} from 'app/styles/heading';
import {formatBirthDate} from 'app/helpers/dateHelpers';
import {
  ProfileCard,
  ProfileInfoColumn,
  ProfileInfoColumnContainer,
  ProfilePhoto,
  ProfileStats,
  ProfileStatsData,
  ProfilePhotoWrapper,
} from 'app/components/profile/ProfileStyles';
import {
  TextWithLabel,
  TextWithLabelJustifyContainer,
  IconAndTextWithLabelContainer,
} from 'app/components/textWithLabel/TextWithLabel';
import {LocationOn, Mail, Phone, PhotoCamera} from '@mui/icons-material';

const IndentTextWithLabel = styled(TextWithLabel)`
  margin-left: ${SIZES['40']};
`;

const ContactInfo = ({contact}) => {
  const facts = {
    birthday: contact.birthday ? formatBirthDate(contact.birthday) : '–',
    job: contact.job ? contact.job : '–',
    since: contact.since ? contact.since : '–',
    club: contact.club
      ? {name: contact.club.middleName, url: `/club/${contact.club.slug}`, image: contact.club.image}
      : {name: '–', url: '', image: null},
    address: contact.city
      ? contact.street
        ? contact.postal
          ? `${contact.street}, ${contact.postal} ${contact.city}`
          : `${contact.street}, ${contact.city}`
        : contact.city
      : '–',
    email: contact.email ? contact.email : '–',
    phonePrivate: contact.phone1 ? contact.phone1 : '–',
    phoneBusiness: contact.phone2 ? contact.phone2 : '–',
    phoneMobile: contact.mobile ? contact.mobile : '–',
  };

  let photo;
  let photoSource = 'unbekannt';

  if (contact.image) {
    photo = <Image entity='contact' circle={true} src={contact.image} ratio='1:1' height={100} width={100} />;

    photoSource = contact.image.source ? contact.image.source : 'Unbekannt';
  }

  return (
    <ProfileCard>
      <CardSubheading variant='subheading2'>Persönliche Daten</CardSubheading>
      <TextWithLabelJustifyContainer>
        <ProfileInfoColumnContainer>
          <ProfileInfoColumn>
            <TextWithLabel label='Geburtstag' data={facts.birthday} />
            <TextWithLabel noPaddingBottom={true} label='Funktion' data={facts.job} />
          </ProfileInfoColumn>
          <ProfilePhotoWrapper>
            <ProfilePhoto>{photo}</ProfilePhoto>
          </ProfilePhotoWrapper>
          <ProfileInfoColumn>
            <TextWithLabel alignment='right' label='Im Amt seit' data={facts.since} />
            <TextWithLabel
              alignment='right'
              noPaddingBottom={true}
              label='Aktueller Verein'
              data={facts.club.name}
              link={facts.club.url}
              img={{src: facts.club.image, type: 'emblem'}}
              decoration={facts.club.name !== '–'}
            />
          </ProfileInfoColumn>
        </ProfileInfoColumnContainer>
      </TextWithLabelJustifyContainer>
      <ProfileStats>
        <ProfileStatsData>
          <PhotoCamera fontSize='inherit' />
          <Typography variant='caption1'>{photoSource}</Typography>
        </ProfileStatsData>
      </ProfileStats>
      <CardSubheading variant='subheading2'>Kontaktdaten</CardSubheading>
      <IconAndTextWithLabelContainer>
        <LocationOn />
        <TextWithLabel label='Anschrift' data={facts.address} />
      </IconAndTextWithLabelContainer>
      <IconAndTextWithLabelContainer>
        <Mail />
        <TextWithLabel label='E-Mail' data={facts.email} />
      </IconAndTextWithLabelContainer>
      <IconAndTextWithLabelContainer>
        <Phone />
        <TextWithLabel label='Privat' data={facts.phonePrivate} />
      </IconAndTextWithLabelContainer>
      <IndentTextWithLabel label='Geschäftlich' data={facts.phoneBusiness} />
      <IndentTextWithLabel label='Mobil' data={facts.phoneMobile} />
    </ProfileCard>
  );
};

export default ContactInfo;
